<p *ngIf="platformFee" class="platform-fee">Ketto’s <span><span class="font-s">0</span>% Platform fees*</span> ensures maximum funds for you</p>
<button class="start-fundraiser-btn" mat-raised-button (click)="sendEvent('English')"
  [style.width]="width" [style.height]="height" [style.font-size]="font" [style.line-height]="lineHeight" [innerHTML]="label">
</button>
